module.exports = new __parcel__URL__("Charlie_Text-Italic.cb25c310.woff").toString();